module.exports = __webpack_public_path__ + "static/img/index_ad_cw.b2871f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/index_ad_cw.png
// module id = KtwS
// module chunks = 192